import { useBahasa } from './i18n'

const NAMA = { id: 'Indonesia', en: 'English' }

/**
 * Penukar bahasa. Ditaruh di rel navigasi DAN di layar login — karena orang yang
 * belum masuk juga perlu membacanya, dan itu keadaan yang paling mudah terlupa.
 */
export default function PemilihBahasa() {
  const { bahasa, setBahasa, bahasaTersedia, t } = useBahasa()
  return (
    <label className="flex items-center gap-1.5">
      <span className="sr-only">{t('umum.bahasa')}</span>
      <select
        value={bahasa}
        onChange={(e) => setBahasa(e.target.value)}
        aria-label={t('umum.bahasa')}
        className="text-[11px] text-ink2 bg-surface border border-line rounded px-1.5 py-1 cursor-pointer"
      >
        {bahasaTersedia.map((b) => (
          <option key={b} value={b}>{NAMA[b] ?? b}</option>
        ))}
      </select>
    </label>
  )
}
